export function buildCommonContext(globalContextManager, userContextManager, accountContextManager) {
    return {
        view: {
            referrer: document.referrer,
            url: window.location.href,
        },
        context: globalContextManager.getContext(),
        user: userContextManager.getContext(),
        account: accountContextManager.getContext(),
    };
}
//# sourceMappingURL=commonContext.js.map